import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import MediaGroup from "@/pages/MediaGroup";
import Apply from "@/pages/Apply";
import Sponsor from "@/pages/Sponsor";
import Attend from "@/pages/Attend";
import Partners from "@/pages/Partners";
import News from "@/pages/News";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Tickets from "@/pages/Tickets";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckinAttendee from "@/pages/CheckinAttendee";
import { Privacy, Terms, Accessibility } from "@/pages/Legal";
import { AuthProvider } from "@/admin/AuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminShell from "@/admin/AdminShell";
import CheckinScanner from "@/admin/CheckinScanner";
import ShowConsole from "@/admin/ShowConsole";
import ResultsDashboard from "@/admin/ResultsDashboard";
import ChangePassword from "@/admin/ChangePassword";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/media-group" element={<MediaGroup />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/sponsor" element={<Sponsor />} />
        <Route path="/attend" element={<Attend />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/news" element={<News />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkin/:token" element={<CheckinAttendee />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/accessibility" element={<Accessibility />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/change-password" element={<ChangePassword />} />
            <Route path="/admin/checkin" element={<CheckinScanner />} />
            <Route path="/admin/console" element={<ShowConsole />} />
            <Route path="/admin/console/:eventId" element={<ShowConsole />} />
            <Route path="/admin/results" element={<ResultsDashboard />} />
            <Route path="/admin/results/:eventId" element={<ResultsDashboard />} />
            <Route path="/admin" element={<AdminShell />} />
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </AuthProvider>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#101C35",
              border: "1px solid #14213D",
              color: "#FFFFFF",
              borderRadius: 0,
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
